import {
  SEARCH_PARAM_ORG_ID,
  SEARCH_PARAM_SITE_ID,
} from 'routes/(global_search_params)/-searchParams'
import { z } from 'zod'

const stringArraySearchParam = z
  .union([z.string(), z.array(z.string())])
  .transform((value) => (typeof value === 'string' ? [value] : value))
  .optional()

export const shipsSearchParams = z.object({
  name: z.string().optional(),
  class: stringArraySearchParam,
  fleet: stringArraySearchParam,
  homeport: stringArraySearchParam,
  commissionDate: z.array(z.string()).optional(),
  lastInspectionDate: z.array(z.string()).optional(),
  search: z.string().optional(),
})

export type ShipsSearch = z.infer<typeof shipsSearchParams>

export const createShipsSearch = ({
  orgId,
  siteId,
}: {
  orgId: string | undefined
  siteId: string | undefined
}) => ({
  [SEARCH_PARAM_ORG_ID]: orgId,
  [SEARCH_PARAM_SITE_ID]: siteId,
})
